// extracted by mini-css-extract-plugin
module.exports = {"prefooterContainer":"prefooter_prefooterContainer__Vp0aH","prefooter":"prefooter_prefooter__Gyr64"};